import React from 'react'
import { observer } from 'mobx-react-lite'
import {
    Box,
    Typography,
    Tooltip,
    Chip,
    Stack,
    Divider
} from '@mui/material'
import SpeedIcon from '@mui/icons-material/Speed'
import { Icons } from '../../utils/utilities'
import { useMeetingActionsContext } from '../../contexts/meetingactions.context'
import { useMeetingStore } from '../../store/meeting.store'

const AgoraStats = observer( () => {
    const {
        networkStats,
        sessionStats,
        networkQualityColor,
        networkQualityLabel,
        connectionStatus
    } = useMeetingStore()

    const ExtendedStats = (
        <Box sx={{ p: 0.5 }}>
            <Typography variant="subtitle2" sx={{ mb: 0.5, borderBottom: '1px solid rgba(255,255,255,0.2)' }}>
                Connection Details
            </Typography>
            <Stack spacing={0.5}>
                <Typography variant="caption" display="block">
                    <strong>Latency (RTT):</strong> {sessionStats.rtt || 0}ms
                </Typography>
                <Typography variant="caption" display="block">
                    <strong>Upload:</strong> {( sessionStats.outgoingBitrate / 1000 ).toFixed( 2 )} Mbps
                </Typography>
                <Typography variant="caption" display="block">
                    <strong>Download:</strong> {( sessionStats.incomingBitrate / 1000 ).toFixed( 2 )} Mbps
                </Typography>
                {sessionStats.loss !== undefined && (
                    <Typography variant="caption" display="block">
                        <strong>Packet Loss:</strong> {sessionStats.loss}%
                    </Typography>
                )}
            </Stack>
        </Box>
    )

    return (
        <Tooltip title={ExtendedStats} arrow placement="bottom">
            <Stack
                direction="row"
                alignItems="center"
                spacing={1}
                sx={{
                    cursor: 'pointer',
                    px: 1.5,
                    py: 0.5,
                    borderRadius: '20px',
                    bgcolor: 'action.hover',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                        bgcolor: 'action.selected'
                    }
                }}
            >
                {/* Status Dot */}
                <Box
                    sx={{
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        bgcolor: networkQualityColor,
                        boxShadow: `0 0 6px ${networkQualityColor}`
                    }}
                />

                <Typography display="flex" alignItems="center" component="span">{Icons.default.Wifi}</Typography>


                {/* Main Label */}
                <Typography
                    display={{ xs: "none", md: "block" }}
                    variant="body2"
                    sx={{
                        fontWeight: 500,
                        color: 'text.primary',
                        fontSize: '0.85rem'
                    }}
                >
                    {networkQualityLabel}
                </Typography>

            </Stack>
        </Tooltip>
    )
} )

export default AgoraStats